import { $Q, $Qll } from "../utils/querySelector";

export const categoryAccordion = () => {
  const faqCategories = $Qll(".faqcategory--list-item");

  if (faqCategories) {
    faqCategories.forEach(category => {
      category.addEventListener("click", () => {
        setActive(category, faqCategories);
      });
    });
  }
}

const setActive = (category, categories) => {
  if (!category.classList.contains("item-active")) {
    categories.forEach(element => {
      element.classList.remove("item-active");
    });
    category.classList.add("item-active");
  }

  showAccordion(category);
}

const showAccordion = (category) => {
  const idAccordion = category.dataset.accordion;
  const accordion = $Q(`#${idAccordion}`);
  const accordions = $Qll(".spec-accordion__items");

  if (!accordion.classList.contains("item-active")) {
    accordions.forEach(element => {
      element.classList.remove("item-active");
    });
    accordion.classList.add("item-active");
  }
}